import Http from "../../http";

class DashboardServices {
    static async findAll() {
        return Http.get('/dashboard');
    }
}
export default DashboardServices;
